(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementMarqueeComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-marquee__track');
      this.unit = this.track && this.track.querySelector('.announcement-marquee__content[aria-hidden]');
      if (!this.track || !this.unit) return;
      this.unitSeconds = parseFloat(this.dataset.unitSeconds) || 18;
      this.resizeObserver = new ResizeObserver(() => this.fill());
      this.resizeObserver.observe(this);
      this.fill();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    fill() {
      const unitWidth = this.unit.getBoundingClientRect().width;
      const containerWidth = this.clientWidth;
      if (!unitWidth || !containerWidth) return;

      // The track holds two identical halves; translateX(-50%) is only
      // seamless when each half is at least as wide as the container.
      const copiesPerHalf = Math.max(2, Math.ceil(containerWidth / unitWidth) + 1);
      const needed = copiesPerHalf * 2;
      const current = this.track.querySelectorAll('.announcement-marquee__content').length;

      for (let i = current; i < needed; i++) {
        const clone = this.unit.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }

      // Keep perceived speed constant regardless of copy count.
      const halfWidth = unitWidth * Math.max(copiesPerHalf, Math.floor(current / 2));
      const pxPerSecond = unitWidth / this.unitSeconds;
      this.track.style.setProperty('--marquee-duration', `${(halfWidth / pxPerSecond).toFixed(2)}s`);
    }
  }

  if (!customElements.get('announcement-marquee-component')) {
    customElements.define('announcement-marquee-component', AnnouncementMarqueeComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
